import { jsx } from 'react/jsx-runtime';

function ArrowDown() {
  return /*#__PURE__*/jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "6",
    height: "6",
    fill: "none",
    viewBox: "0 0 6 6",
    children: /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.75 1a.75.75 0 0 0-1.5 0v2.19L1.655.594a.75.75 0 1 0-1.06 1.06L3.189 4.25H1a.75.75 0 0 0 0 1.5h4a.748.748 0 0 0 .529-.218l.001-.002.002-.001A.748.748 0 0 0 5.75 5V1Z",
      clipRule: "evenodd"
    })
  });
}

export { ArrowDown };
